// Language: remember the visitor's EN/ES choice made with the toggle or the language offer, and show the
// offer. The first-visit pick runs inline at the top of <head> (snippets/pr-language-pick): a browser that
// prefers Spanish is switched there, before the page paints. For everyone else it leaves window.prLangCheck
// (the country lookup's URL), and here, once the page has loaded, the lookup decides whether to offer the
// other language (snippets/pr-lang-offer). A saved choice turns both off for good.
(() => {
  const remember = (lang) => {
    try {
      localStorage.setItem('pr-lang', lang);
    } catch (e) {
      /* storage blocked */
    }
  };
  document.querySelectorAll('a[data-pr-lang]').forEach((link) =>
    link.addEventListener('click', () => remember(link.dataset.prLang))
  );

  const offer = document.querySelector('[data-pr-lang-offer]');
  const lookup = window.prLangCheck;
  if (!offer || !lookup) return;

  const countries = 'AR BO CL CO CR CU DO EC ES GQ GT HN MX NI PA PE PR PY SV UY VE'.split(' ');
  const stay = offer.querySelector('[data-pr-lang-stay]');
  const close = () => {
    offer.classList.remove('is-shown');
    offer.hidden = true;
  };
  stay?.addEventListener('click', () => {
    remember(stay.dataset.prLangStay);
    close();
  });
  offer.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  const check = () =>
    fetch(`${lookup}?country[enabled]=true`, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const country = data?.detected_values?.country?.handle;
        if (!country) return;
        const wanted = countries.includes(country) ? 'es' : 'en';
        if (wanted !== offer.dataset.prLangOffer) return;
        offer.hidden = false;
        requestAnimationFrame(() => requestAnimationFrame(() => offer.classList.add('is-shown')));
      })
      .catch(() => {});
  // After the page has loaded and gone quiet, so the lookup never competes with it
  const later = () => ('requestIdleCallback' in window ? requestIdleCallback(check, { timeout: 3000 }) : setTimeout(check, 1000));
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });
})();
